import useAuthUser from "@forwardflow/hooks/customHooks/useAuthUser";
import useSentry from "@forwardflow/hooks/useSentry";
import { useEffect } from "react";
import { useLocation, useNavigationType } from "react-router-dom";

export const SentryRouteTracker = () => {
  const location = useLocation();
  const navigationType = useNavigationType();
  const { trackUserAction, setTag, setUser } = useSentry()
  const { data: user } = useAuthUser({ revalidateOnMount: true });

  useEffect(() => {
    trackUserAction('navigation', `Navigation to ${location.pathname}`, {
      from: document.referrer,
      to: location.pathname,
      navigationType,
      timestamp: new Date().toISOString()
    });

    setTag('currentRoute', location.pathname);
  }, [location, navigationType, trackUserAction, setTag]);

  useEffect(() => {
    if (user) {
      const pageName = location.pathname.replace('/', '') || 'home';
      trackUserAction('current_page', `User accessed ${pageName}`);

      setUser({
        id: user?.id,
        username: `${user?.firstName || ''} ${user?.lastName || ''}`.trim(),
        verified: user?.verified === true,
        firstLogin: user?.firstSignIn === false,
      });
    }
  }, [trackUserAction, setUser, user, location]);

  return null;
};